<body [ngClass]="{'xSmallScreen': xSmallScreen}">
    <div [ngClass]="{
        'position-user':userRank,
         'position-first':rank === 1, 
         'position-second':rank === 2, 
         'position-third':rank === 3, 
         'position': (+rank > 3 || rank === '--')}">
        <p>{{rank}}</p><span *ngIf="+rank <= 3" class="abbreviation">{{getAbbreviation()}}</span>
    </div>
</body>